import { render } from "./ConfigV2.vue?vue&type=template&id=5a4f4014"
import script from "./ConfigV2.vue?vue&type=script&lang=js"
export * from "./ConfigV2.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2816855756/src/bitbucket.org/island-c/cayman-fe-operator/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__